<template>
  <div class="input_field" :class="[isDisabled && 'disabled']">
    <label
      v-if="label !== ''"
      class="medium-s t-white font-family-2"
      :class="labelClass"
      >{{ label }}</label
    >
    <div
      class="input_field_container d-flex-row"
      :class="[variant, size, error.length > 0 ? 'errored' : '', fieldClass]"
      :style="{
        justifyContent: iconStart ? 'flex-start' : 'space-between',
      }"
    >
      <component :is="firstIcon" v-if="iconStart"></component>
      <!-- <email-icon /> -->
      <input
        :type="type === 'number' ? 'text' : type"
        class="input_field"
        :required="required"
        :class="[iconEnd || iconStart ? 'flex-8' : 'flex-10']"
        :placeholder="placeholder"
        :value="modelValue"
        @input="handleInput"
        :pattern="pattern"
        :inputmode="type === 'number' ? 'numeric' : null"
        :step="step"
        :disabled="isDisabled"
        :readonly="isReadonly"
      />
      <component :is="secondIcon" v-if="iconEnd"></component>

      <!-- <email-icon /> -->
    </div>
    <label v-if="error" class="caps medium-s t-danger font-family-2">{{
      error
    }}</label>
  </div>
</template>

<script>
import EmailIcon from "../icons/EmailIcon.vue";
import SearchOutlinedIcon from "../icons/SearchOutlinedIcon.vue";
export default {
  data() {
    return {};
  },
  props: {
    iconStart: {
      type: String,
      default: "",
    },
    iconEnd: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: "Placeholder",
    },
    label: {
      type: String,
      default: "",
    },
    modelValue: {
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "",
    },
    fieldClass: {
      type: String,
      default: "space-between",
    },
    labelClass: {
      type: String,
      default: "",
    },
    isDisabled: {
      default: false,
    },
    required: {
      default: false,
    },
    acceptFloat: {
      default: false,
    },
    isReadonly: {
      default: false,
    },
  },
  methods: {
    handleInput(event) {
      // Only emit update:modelValue if the component is not disabled
      if (!this.isDisabled) {
        this.$emit("update:modelValue", event.target.value);
      }
    },
  },
  computed: {
    firstIcon() {
      return this.iconStart;
    },
    secondIcon() {
      return this.iconEnd;
    },
    step() {
      if (this.type === "number") {
        if (this.acceptFloat) {
          return "any";
        }
      }
      return null;
    },
    pattern() {
      if (this.type === "number") {
        if (this.acceptFloat) {
          return "^[0-9]+([.][0-9]+)?$";
        }
        return "[0-9]*";
      }
      return null;
    },
  },
  components: {
    EmailIcon,
    SearchOutlinedIcon,
    // CopyIcon,
  },
};
</script>
